
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.09 22.92A11.317 11.317 0 0121.291 4.71M4.12 22.84c-1.438 2.52-1.92 4.474-1.107 5.288 1.233 1.232 5.09-.51 9.558-4.053M17.684 23.18l-4.245-4.245 9.434-9.434a5.992 5.992 0 012.79-1.577l2.427-.61a1 1 0 011.213 1.214l-.607 2.428a5.998 5.998 0 01-1.58 2.789l-9.432 9.435z","stroke":"#121131","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.44 18.936l-3.476-1.158a.5.5 0 01-.195-.83l1.211-1.212a4.01 4.01 0 014.105-.969l1.897.631-3.541 3.538zM17.686 23.18l1.158 3.477a.5.5 0 00.83.196l1.212-1.212a4.012 4.012 0 00.968-4.104l-.63-1.897-3.538 3.54z","stroke":"#121131","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    